<template lang="pug">
.work-orders-main-wrapper
  .work-order-details
    .row
      .col-md-12
        InertiaLink.action.blank-link.m-0(:href="workOrdersBackUrl")
          i.hi.hi-left.hi-16.text-blue.mr-5
          | Work orders
    .d-flex.align-items-center.justify-content-between.mb-10.flex-wrap
      .work-order-name.my-10
        h4.m-0
          | {{ workOrderName }}
        small.work-order-status.label(
          v-for="(woState, index) in work_order.wo_states"
          :key="index"
          :class="woStatusStyleClass(woState, index === lastWoStateIndex)"
        )
          | {{ woState ? woState.name : 'Open' }}
      .table-actions-wrapper
        .table-actions-right.d-flex.align-items-center.justify-content-start.justify-content-md-end
          AppButton(
            type="primary"
            size="sm"
            @click="onOpenEditWorkOrderDialog(tabs.general)"
          ) Edit
          AppButton(
            type="success"
            size="sm"
            @click="confirmArchiveWorkOrder(work_order, workOrdersBackUrl)"
          ) Mark as closed

    //- //- Enhancement: we decided to not show this section since the behavior of the add button is a moot point for now
    //- .row.mb-15
    //-   .col-md-12
    //-     a.add-work-order-assignee(href="#" @click.prevent="onOpenEditWorkOrderDialog(tabs.schedule)")
    //-       .avatar.avatar-medium.oval.text-center
    //-         i.hi.hi-16.hi-invites
    //-     template(v-if="assignees.length")
    //-       HubAvatar(
    //-         v-for="assignee in assignees"
    //-         :key="assignee.id"
    //-         :user-id="assignee.id"
    //-         avatar-style="medium"
    //-       )
    //-     a(v-else href="#" @click.prevent="onOpenEditWorkOrderDialog(tabs.schedule)") Add assignees

    .d-flex.flex-wrap
      WorkOrderDetailsInfoBox.client-info(
        :value="work_order.client"
        name="Client"
        icon="hi-user-big"
        @edit="onOpenEditWorkOrderDialog(tabs.general)"
      )
        template(#when-present)
          .client-name-row.row
            .col-md-12
              AppAvatarInitial(:text="work_order.client.name")
              span.client-name {{ work_order.client.name }}
          .client-phone-row.row.mt-5
            .col-md-12
              .client-phone(v-if="work_order.client.phone") {{ work_order.client.phone }}
              a.fake-ajax-link(
                v-else
                @click.stop="onOpenEditClientDialog"
              ) Add phone number
          .client-email-row.row
            .col-md-12
              .client-email.ellipsis(v-if="work_order.client.email") {{ work_order.client.email }}
              a.fake-ajax-link(
                v-else
                @click.stop="onOpenEditClientDialog"
              ) Add email

      WorkOrderDetailsInfoBox(
        :value="address"
        name="Address"
        icon="hi-pin"
        @edit="onOpenEditWorkOrderDialog(tabs.jobSite)"
      )
        template(#when-present)
          .row
            .col-md-12
              //- should we trim the address if too long?
              .work-order-address {{ address }}
        template(#when-empty)
          .row.mt-5
            .col-md-12.text-center
              img.map-illustration(
                :src="addressMapImageUrl"
                alt="Add address"
                height="52"
              )
          .row.mt-20
            .col-md-12.text-center
              a.add-address-link(
                href="#"
                @click.stop="onOpenEditWorkOrderDialog(tabs.jobSite)"
              ) Add address

      WorkOrderDetailsInfoBox(
        :value="nextJob"
        name="Next job"
        icon="hi-attendance"
        @edit="onOpenEditNextJob(nextJob)"
      )
        template(#when-present)
          .row
            .next-job-info.col-md-12
              | {{ $filters.formatDate(nextJob.startsAt) }}
              br
              | {{ $filters.lowercase($filters.formatTimeRangeNoSeconds(nextJob.startsAt, nextJob.stopsAt)) }}{{ nextJob.timeZoneAbbr ? ` ${nextJob.timeZoneAbbr}` : '' }}

          .row.mt-5(v-if="jobIsRecurrent(nextJob)")
            .d-flex.align-items-baseline.col-md-12
              i.hi.hi-refresh.mr-5
              p {{ scheduleTooltip(nextJob.schedule) }}

        template(#when-empty)
          .row.mt-5
            .col-md-12.text-center
              img.schedule-job-illustration(
                :src="scheduleJobImageUrl"
                alt="Schedule a job"
                height="52"
              )
          .row.mt-20
            .col-md-12.text-center
              a#schedule-job-link(
                href="#"
                @click.stop="onOpenAddJobDialog"
              ) Schedule a job

      WorkOrderDetailsInfoBox(
        v-if="canManageBudget"
        :value="work_order.has_budget"
        name="Budget"
        icon="hi-calculator-outline"
        @edit="onOpenEditWorkOrderDialog(tabs.budget)"
      )
        template(#when-present)
          .budget-spent-row.row
            .col-md-12
              strong.budget-spent
                template(v-if="isHoursType") {{ budgetHoursSpent }}
                template(v-else) {{ $filters.currency(budgetSpent, organization.currency) }}
              span /
              span.budget-cost.text-muted
                template(v-if="isHoursType") {{ budgetHours }}
                template(v-else) {{ $filters.currency(work_order.budget.cost, organization.currency) }}

          .budget-recurrence-row.row(v-if="work_order.budget.recurrence")
            .col-md-12
              i.hi.hi-12.hi-refresh.mr-5
              span.budget-recurrence.text-capitalize {{ work_order.budget.recurrence }}

          .budget-progress-row.row
            .col-md-12
              AppProgressBar(
                :tracked="budgetSpent"
                :total="totalProgressBar"
              )

          .budget-status-row.row.small
            .col-md-4
              span.budget-percentage-used {{ budgetPercentageUsed }}
            .col-md-8.text-right
              span.budget-amount-remaining {{ budgetAmountRemaining }} remaining

        template(#when-empty)
          .row.mt-5
            .col-md-12.text-center
              img.budget-illustration(
                :src="budgetImageUrl"
                alt="SetBudget"
                height="52"
              )
          .row.mt-20
            .col-md-12.text-center
              a.set-budget(
                href="#"
                @click.stop="onOpenEditWorkOrderDialog(tabs.budget)"
              ) Set a budget
    .row
      .col-xs-12
        h4 Instructions
        .work-order-instructions(v-if="work_order.instructions")
          AppExcerpt
            p.break-word(
              v-for="(line, index) in instructionsLines"
              :key="line + index"
            )
              template(v-if="line.length") {{ line }}
              template(v-else) &nbsp;
        label.control-label-btn(v-else)
          i.hi.hi-16.hi-group-by
          a(
            href="#"
            @click.prevent="onOpenEditWorkOrderDialog(tabs.general)"
          ) Add instructions

    WorkOrdersJobsSection(
      :all-jobs="allJobs"
      :end-date="jobs_query.stop_date"
      :start-date="jobs_query.start_date"
      :jobs-query-status="jobs_query.status"
      @show-job="onOpenShowJobDialog"
      @edit-job="onOpenEditJobDialog"
      @delete-job="confirmDeleteJob"
      @complete-job="onCompleteJob"
      @reopen-job="onReopenJob"
      @new-job="onOpenAddJobDialog"
      @page-changed="onPageChange"
      @status-changed="onStatusChange"
      @date-range-change="onDateRangeChange"
    )

    WorkOrdersDialog(
      v-if="showEditWorkOrderDialog"
      editing
      :editing-work-order="work_order"
      :default-tab="selectedEditWorkOrderDialogTab"
      :can-manage-budget="canManageBudget"
      :grouped-clients="groupedClientsForSelect"
      @close="onCloseEditWorkOrderDialog"
    )

    JobsDialog#new-job-dialog(
      v-if="showAddJobDialog"
      :organization="organization"
      :time-zone="timeZone"
      :time-zone-abbr="timeZoneAbbr"
      :real-org-time-zone="realOrgTimeZone"
      :work-order="work_order"
      :start-week-on="startWeekOn"
      :active-organization-members="activeOrganizationMembers"
      @close="onCloseAddJobDialog"
    )

    JobsDialog#edit-job-dialog(
      v-if="showEditJobDialog"
      editing
      :job="editingJob"
      :time-zone="timeZone"
      :time-zone-abbr="timeZoneAbbr"
      :real-org-time-zone="realOrgTimeZone"
      :work-order="work_order"
      :start-week-on="startWeekOn"
      :active-organization-members="activeOrganizationMembers"
      @close="onCloseEditJobDialog"
      @close-view-job="onCloseShowJobDialog"
    )

    ShowJobDialog#show-job-dialog(
      v-if="work_order && showViewJobDialog"
      :job="viewingJob"
      :work-order="work_order"
      :can-edit-jobs="canEditJobs"
      :processing-job="processingJob"
      @close="onCloseShowJobDialog"
      @edit-job="onOpenEditJobDialog"
      @reopen-job="onReopenJob"
      @complete-job="onCompleteJob"
    )

    RecurringJobsDialogManager
</template>

<script>
import { formatHours, formatInternalDate } from '~/utils/time_utils';
import { InertiaFlashWatcher, mapInertiaProps } from '~/utils/inertia';
import { applyTemplate as applyUrlTemplate } from '~/utils/url_template';
import {
  canManageBudget,
  realOrgTimeZone,
  groupedClientsForSelect,
  activeOrganizationMembers,
  addWorkOrdersValidationRules,
} from '~/utils/work_orders';
import { WORK_ORDERS_URL, BUDGET_TYPE_HOURS, WORK_ORDER_DIALOG_TABS } from '~/app_constants';
import { IMAGE_WORK_ORDERS_MAP, IMAGE_WORK_ORDERS_BUDGET, IMAGE_WORK_ORDERS_SCHEDULE_JOB } from '~/rails_assets';
import { RecurringJobs, WorkOrderActions, WorkOrderJobActions } from '~/mixins';
import { cleanWorkOrder, cleanJob } from '~/stores/WorkOrderStore/common/utils';
import JobsDialog from '~/components/work_orders/jobs_dialog/JobsDialog.vue';
import ShowJobDialog from '~/components/work_orders/jobs_dialog/ShowJobDialog.vue';
import WorkOrdersDialog from '~/components/work_orders/dialog/WorkOrdersDialog.vue';
import WorkOrdersJobsSection from '~/components/work_orders/details_page/WorkOrdersJobsSection.vue';
import WorkOrderDetailsInfoBox from '~/components/work_orders/details_page/WorkOrderDetailsInfoBox.vue';
import RecurringJobsDialogManager from '~/components/work_orders/jobs_dialog/RecurringJobsDialogManager.vue';
import PhoneInputMixin from '~/mixins/WorkOrders/PhoneInputMixin';

// Add VeeValidate rules
addWorkOrdersValidationRules();

export default {
  name: 'WorkOrdersShow',
  components: {
    JobsDialog,
    ShowJobDialog,
    WorkOrdersDialog,
    WorkOrdersJobsSection,
    WorkOrderDetailsInfoBox,
    RecurringJobsDialogManager,
  },
  mixins: [RecurringJobs, PhoneInputMixin, WorkOrderActions, InertiaFlashWatcher, WorkOrderJobActions],
  props: {
    beta_dialog: Object,
    active_org_members: Array,
    clients: Array,
    current_user: Object,
    new_client_url: String,
    edit_client_url: String,
    googleMapsKey: String,
    is_owner_manager: Boolean,
    job_schedules: Array,
    job_site_minimum_radius: Number,
    jobs: Array,
    jobs_assignees: Array,
    jobs_query: Object,
    organization_members: Array,
    pagination: Object,
    time_zone: String,
    visits_report_url: String,
    wo_assignees: Array,
  },
  data() {
    return {
      viewingJob: null,
      editingJob: null,
      workOrdersBackUrl: null,
      showAddJobDialog: false,
      showViewJobDialog: false,
      showEditJobDialog: false,
      tabs: WORK_ORDER_DIALOG_TABS,
      showEditWorkOrderDialog: false,
      budgetImageUrl: IMAGE_WORK_ORDERS_BUDGET,
      addressMapImageUrl: IMAGE_WORK_ORDERS_MAP,
      scheduleJobImageUrl: IMAGE_WORK_ORDERS_SCHEDULE_JOB,
      selectedEditWorkOrderDialogTab: WORK_ORDER_DIALOG_TABS.general,
    };
  },
  computed: {
    ...mapInertiaProps({
      realOrgTimeZone,
      canManageBudget,
      groupedClientsForSelect,
      activeOrganizationMembers,
      backUrl: 'back_url',
      timeZone: 'organization.time_zone_name',
      startWeekOn: 'organization.start_week_on',
      timeZoneAbbr: 'organization.time_zone_abbr',
      editClientUrl({ edit_client_url: ecu }) {
        const { client } = this.work_order;

        return client ? ecu.replace('__CLIENT_ID__', client.id) : null;
      },
      canEditJobs: ({ is_owner_manager: iom }) => !!iom,
      organizationMembers({ organization_members: organizationMembers }) {
        return organizationMembers
          .map(({ id, name: text }) => ({ id, text }))
          .sort((ua, ub) => ua.text.localeCompare(ub.text));
      },
      allJobs({ jobs, clients, wo_assignees: woAssignees, job_schedules: jobSchedules }) {
        const getters = { organizationMembers: this.organizationMembers };
        const state = {
          clients,
          wo_assignees: woAssignees,
          job_schedules: jobSchedules,
          visits_report_url: this.visits_report_url,
        };

        return jobs.map((job) => cleanJob(job, this.realOrgTimeZone, state, getters));
      },
      work_order({ work_order: wo, organization, org_members: orgMembers, clients, wo_assignees: woAssignees }) {
        const tz = organization.time_zone_name;
        const state = { clients, wo_assignees: woAssignees };
        const getters = { organizationMembers: this.organizationMembers };

        return cleanWorkOrder(wo, state, getters, tz);
      },
    }),
    nextJob() {
      return this.work_order.upcomingJob;
    },
    workOrderName() {
      const { number, client } = this.work_order;

      return number && client ? `${number} - ${client.name}` : '';
    },
    lastWoStateIndex() {
      return (this.work_order.wo_states || []).length - 1 || 0;
    },
    address() {
      return this.work_order.jobSite ? this.work_order.jobSite.address : '';
    },
    isHoursType() {
      return this.work_order.budget.type === BUDGET_TYPE_HOURS;
    },
    totalProgressBar() {
      const { budget = {} } = this.work_order;

      return this.isHoursType ? budget.hours : budget.cost;
    },
    budgetSpent() {
      const { budget: { spent } = {} } = this.work_order;

      return spent;
    },
    budgetHoursSpent() {
      return formatHours(this.budgetSpent);
    },
    budgetHours() {
      const {
        budget: { hours },
      } = this.work_order;

      return formatHours(hours);
    },
    budgetPercentageUsed() {
      const { cost, hours } = this.work_order.budget;
      const getPercentage = (initialBudget) => ((this.budgetSpent / initialBudget) * 100).toFixed(0) + '%';

      return !this.isHoursType ? getPercentage(cost) : getPercentage(hours);
    },
    budgetAmountRemaining() {
      const { cost, hours } = this.work_order.budget;
      const getAmountRemaining = (initialBudget) => initialBudget - this.budgetSpent;
      const remaining = Math.max(0, getAmountRemaining(!this.isHoursType ? cost : hours));

      return !this.isHoursType ? remaining.formatMoney(this.organization.currency) : formatHours(remaining);
    },
    instructionsLines() {
      return (this.work_order.instructions || '').split('\n');
    },
    filterOnlyInertiaKeys() {
      return ['jobs', 'work_order', 'pagination', 'jobs_query', 'wo_assignees', 'job_scheduled', 'jobs_assignees'];
    },
  },
  watch: {
    allJobs(newJobs) {
      if (!newJobs || !newJobs.length) {
        return;
      }

      if (this.viewingJob) {
        const viewingJobId = this.viewingJob.id;

        this.viewingJob = newJobs.find((job) => job.id === viewingJobId);
        this.showViewJobDialog = !!this.viewingJob;
      }

      if (this.editingJob) {
        const editingJobId = this.editingJob.id;

        this.editingJob = newJobs.find((job) => job.id === editingJobId);
        this.showEditJobDialog = !!this.editingJob;
      }
    },
  },
  created() {
    // Must be set before the first render: Inertia v3's `Link` throws on a `null` href.
    this.setWorkOrdersIndexPath();
  },
  mounted() {
    AjaxDialog.registerHook('response', 'updateClientResponse', (data, status) => {
      if (status === 'success' && !!data.client) {
        this.$inertia.reload({
          only: ['clients'],
        });
      }
    });
  },
  methods: {
    setWorkOrdersIndexPath() {
      const propsBackUrl = this.backUrl ? new URL(this.backUrl) : {};
      const fallbackPathname = applyUrlTemplate(WORK_ORDERS_URL, {
        organizationId: this.organization.id,
      });
      // If the backUrl is the index page, use that and append the search from the params
      const isIndexPathname = propsBackUrl.pathname === fallbackPathname;
      const pathname = isIndexPathname ? propsBackUrl.pathname : fallbackPathname;
      const url = new URL(pathname, window.location.origin);

      if (isIndexPathname) {
        if (propsBackUrl.search) {
          const searchParams = new URLSearchParams(propsBackUrl.search);

          searchParams.delete('schedule_work');
          url.search = searchParams.toString();
        }
      }

      this.workOrdersBackUrl = url.toString();
    },
    // Work order methods
    woStatusStyleClass(woState, isLast) {
      const margin = isLast ? '' : ` mr-15`;

      return (woState ? `label-${woState.symbol}` : 'label-open') + margin;
    },
    onOpenEditWorkOrderDialog(tab = WORK_ORDER_DIALOG_TABS.general) {
      this.selectedEditWorkOrderDialogTab = tab;
      this.showEditWorkOrderDialog = true;
    },
    onCloseEditWorkOrderDialog() {
      this.showEditWorkOrderDialog = false;
    },

    // Jobs methods
    onFiltersChange(newPartialFilters) {
      const { origin, pathname } = window.location;
      const newFilters = new URLSearchParams(
        Object.entries({
          ...this.jobs_query,
          ...newPartialFilters,
        }).filter(([, filter]) => !!filter),
      );
      const url = new URL(pathname, origin);

      url.search = newFilters.toString();

      this.$inertia.visit(url.toString(), {
        only: this.filterOnlyInertiaKeys,
      });
    },
    onPageChange(page) {
      this.onFiltersChange({ page });
    },
    onStatusChange(newStatusFilter) {
      this.onFiltersChange({ page: 1, status: newStatusFilter });
    },
    onDateRangeChange({ start, end }) {
      this.onFiltersChange({
        page: 1,
        start_date: formatInternalDate(start),
        stop_date: formatInternalDate(end),
      });
    },
    onOpenEditClientDialog() {
      if (this.editClientUrl) {
        AjaxDialog.run(this.editClientUrl);
      }
    },
    onOpenShowJobDialog(job) {
      if (job && job.id) {
        this.viewingJob = job;
        this.showViewJobDialog = true;
      }
    },
    onOpenAddJobDialog() {
      this.showAddJobDialog = true;
    },
    onCloseAddJobDialog() {
      this.showAddJobDialog = false;
    },
    onOpenEditNextJob(nextJob) {
      if (nextJob) {
        // Try and find the job in the list of jobs
        // and open the edit dialog if it's found
        return this.onOpenEditJobDialog(this.allJobs.find((job) => job.id === nextJob.id));
      }

      // Otherwise, open the add job dialog
      this.onOpenAddJobDialog();
    },
    onOpenEditJobDialog(job) {
      if (job) {
        this.editingJob = job;
        this.showEditJobDialog = true;
      }
    },
    onCloseShowJobDialog() {
      this.viewingJob = null;
      this.showViewJobDialog = false;
    },
    onCloseEditJobDialog() {
      this.editingJob = null;
      this.showEditJobDialog = false;
    },
  },
};
</script>
